import { render } from "./designfood.vue?vue&type=template&id=166bf835&scoped=true"
import script from "./designfood.vue?vue&type=script&lang=js"
export * from "./designfood.vue?vue&type=script&lang=js"

import "./designfood.vue?vue&type=style&index=0&id=166bf835&scoped=true&lang=css"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166bf835"]])

export default __exports__